/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  OptOutGroupDTO,
  OptOutGroupDTOOptional,
  OptOutGroupDTOMetaI,
  OptOutGroupDTOTrackedI,
} from "./opt-out-group-dto";
import { OptOutGroupDTOTracked, OptOutGroupDTOMeta } from "./opt-out-group-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OptOutRequestDTO,
  OptOutRequestDTOOptional,
  OptOutRequestDTOMetaI,
  OptOutRequestDTOTrackedI,
} from "./opt-out-request-dto";
import {
  OptOutRequestDTOTracked,
  OptOutRequestDTOMeta,
} from "./opt-out-request-dto";

/**
 *
 * @export
 * @interface OptOutGroupWithStatusDTO
 */
export interface OptOutGroupWithStatusDTOOptional {
  /**
   *
   * @type {OptOutGroupDTO}
   * @memberof OptOutGroupWithStatusDTO
   */
  group?: OptOutGroupDTOOptional;
  /**
   * true if user has opted out of this group
   * @type {boolean}
   * @memberof OptOutGroupWithStatusDTO
   */
  optedOut?: boolean;
  /**
   *
   * @type {OptOutRequestDTO}
   * @memberof OptOutGroupWithStatusDTO
   */
  optOutRequest?: OptOutRequestDTOOptional;
}

export interface OptOutGroupWithStatusDTO extends OptOutGroupWithStatusDTOOptional {
  /**
   *
   * @type {OptOutGroupDTO}
   * @memberof OptOutGroupWithStatusDTO
   */
  group: OptOutGroupDTO;
  /**
   * true if user has opted out of this group
   * @type {boolean}
   * @memberof OptOutGroupWithStatusDTO
   */
  optedOut: boolean;
  /**
   *
   * @type {OptOutRequestDTO}
   * @memberof OptOutGroupWithStatusDTO
   */
  optOutRequest?: OptOutRequestDTO;
}

export interface OptOutGroupWithStatusDTOTrackedI {
  /**
   *
   * @type {OptOutGroupDTO}
   * @memberof OptOutGroupWithStatusDTO
   */
  group?: OptOutGroupDTOTrackedI;
  groupIsSet: boolean;
  /**
   * true if user has opted out of this group
   * @type {boolean}
   * @memberof OptOutGroupWithStatusDTO
   */
  optedOut?: boolean;
  optedOutIsSet: boolean;
  /**
   *
   * @type {OptOutRequestDTO}
   * @memberof OptOutGroupWithStatusDTO
   */
  optOutRequest?: OptOutRequestDTOTrackedI;
  optOutRequestIsSet: boolean;
}

transformDatesMap.set(
  "OptOutGroupWithStatusDTO",
  function (model: OptOutGroupWithStatusDTO) {
    const transformDatesgroup = transformDatesMap.get("OptOutGroupDTO");
    if (transformDatesgroup && model.group) {
      transformDatesgroup(model.group);
    }
    const transformDatesoptOutRequest =
      transformDatesMap.get("OptOutRequestDTO");
    if (transformDatesoptOutRequest && model.optOutRequest) {
      transformDatesoptOutRequest(model.optOutRequest);
    }
  },
);

export type OptOutGroupWithStatusDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  group: PropertyMeta<OptOutGroupDTOMetaI>;
  //isDate: false
  //isDatetime: false
  optedOut: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  optOutRequest: PropertyMeta<OptOutRequestDTOMetaI>;
}>;

export var OptOutGroupWithStatusDTOMeta: OptOutGroupWithStatusDTOMetaI =
  {} as OptOutGroupWithStatusDTOMetaI;
OptOutGroupWithStatusDTOMeta = typeMeta("OptOutGroupWithStatusDTO", {
  group: propertyMeta("group", false, true, false, OptOutGroupDTOMeta),
  optedOut: propertyMeta("optedOut", false, true, false, MetaTypesBase.boolean),
  optOutRequest: propertyMeta(
    "optOutRequest",
    false,
    false,
    false,
    OptOutRequestDTOMeta,
  ),
});

const metaI = OptOutGroupWithStatusDTOMeta;

registerMeta(() => {});

export class OptOutGroupWithStatusDTOTracked implements OptOutGroupWithStatusDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  group__I?: OptOutGroupDTOTracked = undefined;
  groupIsSet: boolean = false;
  set group(v: undefined | OptOutGroupDTOTracked) {
    if (v !== undefined) {
      this.group__I = v;
      this.groupIsSet = true;
    } else {
      this.group__I = v || undefined;
      this.groupIsSet = true;
    }
    this.changeTracker = true;
  }
  get group() {
    return this.group__I;
  }
  optedOut__I?: boolean = undefined;
  optedOutIsSet: boolean = false;
  set optedOut(v: undefined | boolean) {
    if (v !== undefined) {
      this.optedOut__I = v;
      this.optedOutIsSet = true;
    } else {
      this.optedOut__I = v || undefined;
      this.optedOutIsSet = true;
    }
    this.changeTracker = true;
  }
  get optedOut() {
    return this.optedOut__I;
  }
  optOutRequest__I?: OptOutRequestDTOTracked = undefined;
  optOutRequestIsSet: boolean = false;
  set optOutRequest(v: undefined | OptOutRequestDTOTracked) {
    if (v !== undefined) {
      this.optOutRequest__I = v;
      this.optOutRequestIsSet = true;
    } else {
      this.optOutRequest__I = v || undefined;
      this.optOutRequestIsSet = false;
    }
    this.changeTracker = true;
  }
  get optOutRequest() {
    return this.optOutRequest__I;
  }
  constructor(
    config?: OptOutGroupWithStatusDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.group?.setIds();

    this.optOutRequest?.setIds();
  }
  assignFrom(
    config: OptOutGroupWithStatusDTOOptional,
    options?: AssignOptions,
  ): OptOutGroupWithStatusDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.group && this.groupApplyFilter(optionsRequired.filter)) {
      this.group = new OptOutGroupDTOTracked(config.group, options);
      if (optionsRequired.unassign) this.groupIsSet = false;
      else this.groupIsSet = true;
    }
    if (config.optedOut && this.optedOutApplyFilter(optionsRequired.filter)) {
      this.optedOut = config.optedOut;
      if (optionsRequired.unassign) this.optedOutIsSet = false;
      else this.optedOutIsSet = true;
    }
    if (
      config.optOutRequest &&
      this.optOutRequestApplyFilter(optionsRequired.filter)
    ) {
      this.optOutRequest = new OptOutRequestDTOTracked(
        config.optOutRequest,
        options,
      );
      if (optionsRequired.unassign) this.optOutRequestIsSet = false;
      else this.optOutRequestIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OptOutGroupWithStatusDTOTrackedI {
    const cloned = {} as OptOutGroupWithStatusDTOTrackedI;
    if (
      this.groupIsSetDeep() &&
      this.groupApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.groupIsSet = true;
      cloned.group = this.group?.removeUnset(filter);
    } else {
      //cloned.groupIsSet = false
    }
    if (
      this.optedOutIsSetDeep() &&
      this.optedOutApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optedOutIsSet = true;
      cloned.optedOut = this.optedOut;
    } else {
      //cloned.optedOutIsSet = false
    }
    if (
      this.optOutRequestIsSetDeep() &&
      this.optOutRequestApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optOutRequestIsSet = true;
      cloned.optOutRequest = this.optOutRequest?.removeUnset(filter);
    } else {
      //cloned.optOutRequestIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OptOutGroupWithStatusDTOTrackedI {
    if (!this.groupApplyFilter(filter)) this.groupIsSet = false;
    this.group?.unassignAll(filter);

    if (!this.optedOutApplyFilter(filter)) this.optedOutIsSet = false;

    if (!this.optOutRequestApplyFilter(filter)) this.optOutRequestIsSet = false;
    this.optOutRequest?.unassignAll(filter);

    return this;
  }
  groupApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutGroupWithStatusDTOMeta.group,
      OptOutGroupWithStatusDTOMeta,
      this.group,
      this,
    );
  }
  groupIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.groupIsSet && this.groupApplyFilter(filter)) return true;
    return this.group?.anySet(filter) == true;

    return false;
  }
  optedOutApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutGroupWithStatusDTOMeta.optedOut,
      OptOutGroupWithStatusDTOMeta,
      this.optedOut,
      this,
    );
  }
  optedOutIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.optedOutIsSet && this.optedOutApplyFilter(filter)) return true;

    return false;
  }
  optOutRequestApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutGroupWithStatusDTOMeta.optOutRequest,
      OptOutGroupWithStatusDTOMeta,
      this.optOutRequest,
      this,
    );
  }
  optOutRequestIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.optOutRequestIsSet && this.optOutRequestApplyFilter(filter))
      return true;
    return this.optOutRequest?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.groupIsSetDeep(filter)) return true;
    if (this.optedOutIsSetDeep(filter)) return true;
    if (this.optOutRequestIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
